var Account, Routes, StoreFactory, m, origPopStateHandler, store;

m = require('mithril');

StoreFactory = require('./state/StoreFactory');

Account = require('./state/Account');

Routes = require('./ui/Routes');

store = StoreFactory();

m.route.mode = 'hash';

m.route(document.getElementById('app'), Routes.defaultRoute, Routes.generate(store));

Account.loadAccount(store, 'public');

origPopStateHandler = window.onpopstate;

window.onpopstate = function(evnt) {
  window.onhashchange();
  if (origPopStateHandler != null) {
    return origPopStateHandler(evnt);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvbWFpbi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy9tYWluLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLENBQUEsR0FBSSxPQUFBLENBQVEsU0FBUjs7QUFDSixZQUFBLEdBQWdCLE9BQUEsQ0FBUSxzQkFBUjs7QUFDaEIsT0FBQSxHQUFZLE9BQUEsQ0FBUSxpQkFBUjs7QUFDWixNQUFBLEdBQVksT0FBQSxDQUFRLGFBQVI7O0FBR1osS0FBQSxHQUFRLFlBQUEsQ0FBQTs7QUFHUixDQUFDLENBQUMsS0FBSyxDQUFDLElBQVIsR0FBZTs7QUFDZixDQUFDLENBQUMsS0FBRixDQUFRLFFBQVEsQ0FBQyxjQUFULENBQXdCLEtBQXhCLENBQVIsRUFBd0MsTUFBTSxDQUFDLFlBQS9DLEVBQTZELE1BQU0sQ0FBQyxRQUFQLENBQWdCLEtBQWhCLENBQTdEOztBQUdBLE9BQU8sQ0FBQyxXQUFSLENBQW9CLEtBQXBCLEVBQTJCLFFBQTNCOztBQUlBLG1CQUFBLEdBQXNCLE1BQU0sQ0FBQzs7QUFDN0IsTUFBTSxDQUFDLFVBQVAsR0FBb0IsU0FBQyxJQUFEO0VBQ25CLE1BQU0sQ0FBQyxZQUFQLENBQUE7RUFDQSxJQUE0QiwyQkFBNUI7V0FBQSxtQkFBQSxDQUFvQixJQUFwQixFQUFBOztBQUZtQiJ9
